<template>
  <div class="container pt-5" style="min-height: calc(100vh - 470px)">
    <div class="text-center title-pp font-weight-bold">Offers and Promotions</div>

    <div class="row pt-5">
      <div
        v-if="offersPromo.length > 0"
        class="col-12 col-sm-6 col-md-3 col-lg-4 col-xl-4"
        v-for="(offers , key) in offersPromo"
        :key="key"
      >
        <div class="offers-card">
          <img :src="offers.Image" class="img-fluid" alt="Offer-Poster" />
          <div class="p-3">
            <h6>{{offers.Title}}</h6>
            <p class="text-muted small">{{offers.Description}}.</p>
            <div class="align-items-end d-flex justify-content-between">
              <p class="mb-0 mb-md-2 text-primary small">{{offers.Expiry}}</p>
              <span v-b-modal.offer-modal class="d-md-none pl-3" @click="onClickModal(offers)">
                <svg
                  width="45"
                  height="45"
                  viewBox="0 0 66 66"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M33 66C51.2254 66 66 51.2254 66 33C66 14.7746 51.2254 0 33 0C14.7746 0 0 14.7746 0 33C0 51.2254 14.7746 66 33 66ZM51.066 34.1687C52.3192 32.9353 52.3094 30.9336 51.0482 29.7018L36.1138 15.1152C32.6259 11.7335 27.3938 16.8065 30.8816 20.1882L37.3973 26.5057C38.4839 27.5593 38.1187 28.4134 36.5993 28.4134H18.6996C16.6556 28.4134 15 30.0186 15 32.0005C15 33.9814 16.6556 35.5875 18.6996 35.5875H36.5993C38.1266 35.5875 38.4889 36.4367 37.3973 37.495L30.8816 43.8118C27.3938 47.1935 32.6259 52.2666 36.1138 48.8848L51.066 34.1687Z"
                    fill="url(#paint0_linear)"
                  />
                  <defs>
                    <linearGradient
                      id="paint0_linear"
                      x1="-9.55483"
                      y1="23.646"
                      x2="37.7372"
                      y2="108.756"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stop-color="#E70D00" />
                      <stop offset="1" stop-color="#FA5402" />
                    </linearGradient>
                  </defs>
                </svg>
              </span>
            </div>

            <button
              class="d-none d-md-block btn-gogo"
              @click="onClickModal(offers)"
              v-b-modal.offer-modal
            >View Details</button>
          </div>
        </div>
      </div>
    </div>
    <div v-if="offersPromo.length == 0 && !loading">
      <h5 class="font-weight-bold text-center mb-5">
        <!-- No Offers Available -->
        Coming Soon! Please check back for special offers and promotions. 
        </h5>
    </div>
    <div class="row d-md-none" v-if="loading">
      <div class="col-12 text-center">
        <img src="@/assets/img/loadMore.gif" class="load-more" />
      </div>
    </div>

    <b-modal body-class="p-0" id="offer-modal" size="lg" hide-footer>
      <img :src="offers.Image" class="img-fluid w-100" alt />
      <div class="p-md-4 mb-0 p-3">
        <div class="justify-content-between d-md-flex">
          <div>
            <h5 class="font-weight-bold">{{offers.Title}}</h5>
            <p>{{offers.Description}}</p>
          </div>
          <div class="pl-md-3">
            <div class="text-primary small">Offer valid till:</div>
            <div class="text-nowrap small font-weight-bold">{{offers.Expiry}}</div>
          </div>
        </div>
        <hr />
        <h6 class="font-weight-bold">Terms & Condition</h6>
        <ul class="pl-3 mb-4">
          <li v-html="offers.termsAndCondition"></li>
        </ul>
        <!-- <router-link to="/" class="btn-gogo mx-auto">Browse Movies</router-link> -->
      </div>
    </b-modal>
  </div>
</template>
<script>
import { makeRequest } from "@/helper/internet.js";
import { TokenService } from "@/services/storage.service";
import EventBus from "@/eventBus.js";
export default {
  data() {
    return {
      offersPromo: [],
      offers: {},
      loading: false
    };
  },
  beforeMount() {
    this.fetchOffers();
  },
  beforeDestroy() {
    // EventBus.$emit("FOOTERSET", false);
    // EventBus.$emit("CHECKROUTE", false);
  },
  mounted() {
    // EventBus.$emit("CHECKROUTE", true);
    // EventBus.$emit("BOTTOMTABCHANGE", "2");
  },
  methods: {
    onClickModal: function(data) {
      this.offers = data;
    },
    fetchOffers: function() {
      let token = TokenService.getToken();
      let payload = {
        CityID: 0
      };
      this.loading = true
      makeRequest("/Payment/GetPromotionDetails", "POST", token, payload)
        .then(result => {
          this.offersPromo = result.res.data.Promotions;
          this.loading = false;
          //  EventBus.$emit("FOOTERSET", true);
        })
        .catch(error => {
          console.log("Error", error);
          this.loading = false;
        });
    }
  }
};
</script>

<style>
.offers-card {
  border-radius: 5px;
  max-width: 325px;
  margin-bottom: 50px;
  border: 1px solid #8d99af;
}

@media (max-width: 767px) {
  .offers-card {
    margin: 0 auto;
    margin-bottom: 50px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/offers&promotion.vue